module.exports = __webpack_public_path__ + "img/option_b.ee1c73a8.png";